import {
  SET_VALIDATION_LOADING,
  SET_VALIDATION_ERROR,
  SET_VALIDATION_SUCCESS,
} from "./mutation-types";

export default {
  [SET_VALIDATION_LOADING](state, loading) {
    state.validationLoading = loading;
  },

  [SET_VALIDATION_ERROR](state, error) {
    state.validationError = error;
  },

  [SET_VALIDATION_SUCCESS](state, success) {
    state.validationSuccess = success;
  },
};
